export default __webpack_public_path__ + "static/media/frutas.823c03ad.png";